import React, { useState, useEffect, Fragment, useRef } from 'react';
import PropTypes from 'prop-types';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import MailIcon from '@mui/icons-material/Mail';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { getMenuItems } from './SidebarMenus';
import icmr from '../../assets/icmr.png'
import { Avatar, Collapse, Paper } from '@mui/material';
import { Routes, Route, useNavigate, Navigate, useParams } from "react-router-dom";
import foodnetlogo from '../../assets/foodnetlogo.png'
import cdac from '../../assets/cdac.png'
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChartSimple, faBacteria, faPaw, faShop, faHospitalAlt, faBowlFood } from '@fortawesome/free-solid-svg-icons';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import StorefrontIcon from '@mui/icons-material/Storefront';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import RestaurantIcon from '@mui/icons-material/Restaurant';
import PetsIcon from '@mui/icons-material/Pets';

library.add(faChartSimple);

const drawerWidth = 300;

function ResponsiveDrawer(props) {

    //const [menudata, setmenudata] = useState("Dashboard")

    const navigate = useNavigate();

    const { drawprops } = props;
    const [mobileOpen, setMobileOpen] = React.useState(false);

    const [selectedIndex, setSelectedIndex] = useState();

    const [pathexpopen, setpathexpopen] = useState(false)



    const handlePathClick = () => {
        setpathexpopen(!pathexpopen)
    }


    const handleListItemClick = (event, index, route) => {
        navigate(route)
        //console.log("index ", selectedIndex)
    };

    //////console.log("menus", getMenuItems())

    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };

    useEffect(() => {
        switch (window.location.pathname) {
            case "/dashboard":
                setSelectedIndex(0)
                break
            case "/dashboard/marketSurveillance":
                setSelectedIndex(1)
                break
            case "/dashboard/hospitalSurveillance":
                setSelectedIndex(2)
                break
            case "/dashboard/ssfSurveillance":
                setSelectedIndex(3)
                break
            case "/dashboard/animalSurveillance":
                setSelectedIndex(4)
                break
            case "/dashboard/amrMarketSurveillance":
                setSelectedIndex(5)
                break
            case "/dashboard/amrHospitalSurveillance":
                setSelectedIndex(6)
                break
            case "/dashboard/amrssfSurveillance":
                setSelectedIndex(7)
                break
            case "/dashboard/amrAnimalSurveillance":
                setSelectedIndex(8)
                break
            default:
                break
        }
    }, [])

    const drawer = (
        <div>


            <List
                sx={{ marginTop: '30px', paddingLeft: 1.5 }}>
                <Typography sx={{ marginLeft: 1, fontFamily: 'Rubik, sans-serif', fontWeight: 400, color: 'white', pl: 2, mb: "12px", }} variant="subtitle2" gutterBottom>Aggregated Results</Typography>

                {/* ***************dashboard button**************** */}
                <ListItemButton


                    sx={{
                        '&.Mui-selected': {
                            backgroundColor: '#f3f4f7',
                            borderRadius: 4,
                            position: 'relative',
                            '&:hover': {
                                backgroundColor: '#f3f4f7',
                            },
                            '& .MuiListItemIcon-root': {
                                color: '#1677ff', // Replace 'blue' with your desired color
                                fontSize: '15px'
                            },
                            '& .MuiListItemText-primary': {
                                color: 'blue', // Replace 'blue' with your desired color
                                fontWeight: 1000,
                                fontSize: '15px',
                                fontFamily: 'Rubik, sans-serif'
                            },
                            '&:before': {
                                content: '""',
                                position: 'absolute',
                                width: '40px', // Adjust width as needed
                                height: '40px',
                                backgroundColor: '#212631', // Replace with your desired color
                                borderRadius: "50%",
                                top: '-40px',
                                right: 0,
                                boxShadow: '20px 20px 0 #f3f4f7',
                                zIndex: 1
                            },
                            '&:after': {
                                content: '""',
                                position: 'absolute',
                                width: '40px', // Adjust width as needed
                                height: '40px',
                                backgroundColor: '#212631', // Replace with your desired color
                                borderRadius: "50%",
                                bottom: '-40px',
                                right: 0,
                                boxShadow: '20px -20px 0 #f3f4f7',
                                zIndex: 1
                            }
                        },
                        '&.Mui-focusVisible': {
                            backgroundColor: 'transparent',
                        },
                        '&:hover': {
                            backgroundColor: 'transparent',
                        },
                        '&.Mui-selected:focus': {
                            backgroundColor: '#f3f4f7',
                        },
                        pl: 4
                    }}

                    selected={selectedIndex == 0}
                    onClick={(event) => handleListItemClick(event, 0, "/")}
                >

                    <ListItemIcon sx={{ minWidth: '40px', fontSize: '15px', color: 'white' }}>
                        <span><FontAwesomeIcon icon={faChartSimple} /></span>
                    </ListItemIcon>
                    <ListItemText primary={"Dashboard"} primaryTypographyProps={{
                        style: { fontFamily: 'Rubik, sans-serif', fontWeight: 50, fontSize: '15px' }
                    }} />
                </ListItemButton>

                {/* ***************pathogen details list**************** */}
                <Typography sx={{ marginLeft: 1, fontFamily: 'Rubik, sans-serif', fontWeight: 400, color: 'white', pl: 2, mt: 3, mb: "12px" }} variant="subtitle2" gutterBottom>Pathogen Details</Typography>

                <ListItemButton
                    sx={{
                        '&.Mui-selected': {
                            backgroundColor: '#f3f4f7',
                            borderRadius: 4,
                            position: 'relative',
                            '&:hover': {
                                backgroundColor: '#f3f4f7',
                            },
                            '& .MuiListItemIcon-root': {
                                color: '#1677ff', // Replace 'blue' with your desired color
                                fontSize: '15px'
                            },
                            '& .MuiListItemText-primary': {
                                color: '#1677ff', // Replace 'blue' with your desired color
                                fontWeight: 1000,
                                fontSize: '15px',
                                fontFamily: 'Rubik, sans-serif'
                            },
                            '&:before': {
                                content: '""',
                                position: 'absolute',
                                width: '40px', // Adjust width as needed
                                height: '40px',
                                backgroundColor: '#212631', // Replace with your desired color
                                borderRadius: "50%",
                                top: '-40px',
                                right: 0,
                                boxShadow: '20px 20px 0 #f3f4f7',
                                zIndex: 1
                            },
                            '&:after': {
                                content: '""',
                                position: 'absolute',
                                width: '40px', // Adjust width as needed
                                height: '40px',
                                backgroundColor: '#212631', // Replace with your desired color
                                borderRadius: "50%",
                                bottom: '-40px',
                                right: 0,
                                boxShadow: '20px -20px 0 #f3f4f7',
                                zIndex: 1
                            }
                        },
                        pl: 4
                    }}

                    selected={selectedIndex == 1}
                    onClick={(event) => handleListItemClick(event, 1, "/marketSurveillance")}
                >

                    <ListItemIcon sx={{ minWidth: '40px', fontSize: '15px', color: 'white' }}>
                        <span><i className='bx bxs-store-alt' style={{ fontSize: 20 }} ></i></span>
                    </ListItemIcon>
                    <ListItemText primary={"Market Surveillance"} primaryTypographyProps={{
                        style: { fontFamily: 'Rubik, sans-serif', fontWeight: 50, fontSize: '15px' }
                    }} />
                </ListItemButton>
                <ListItemButton
                    sx={{
                        '&.Mui-selected': {
                            backgroundColor: '#f3f4f7',
                            borderRadius: 4,
                            position: 'relative',
                            '&:hover': {
                                backgroundColor: '#f3f4f7',
                            },
                            '& .MuiListItemIcon-root': {
                                color: '#1677ff', // Replace 'blue' with your desired color
                                fontSize: '15px'
                            },
                            '& .MuiListItemText-primary': {
                                color: '#1677ff', // Replace 'blue' with your desired color
                                fontWeight: 1000,
                                fontSize: '15px',
                                fontFamily: 'Rubik, sans-serif'
                            },
                            '&:before': {
                                content: '""',
                                position: 'absolute',
                                width: '40px', // Adjust width as needed
                                height: '40px',
                                backgroundColor: '#212631', // Replace with your desired color
                                borderRadius: "50%",
                                top: '-40px',
                                right: 0,
                                boxShadow: '20px 20px 0 #f3f4f7',
                                zIndex: 1
                            },
                            '&:after': {
                                content: '""',
                                position: 'absolute',
                                width: '40px', // Adjust width as needed
                                height: '40px',
                                backgroundColor: '#212631', // Replace with your desired color
                                borderRadius: "50%",
                                bottom: '-40px',
                                right: 0,
                                boxShadow: '20px -20px 0 #f3f4f7',
                                zIndex: 1
                            }
                        },
                        pl: 4
                    }}

                    selected={selectedIndex == 2}
                    onClick={(event) => handleListItemClick(event, 2, "/hospitalSurveillance")}
                >

                    <ListItemIcon sx={{ minWidth: '40px', fontSize: '15px', color: 'white' }}>
                        <span><FontAwesomeIcon icon={faHospitalAlt} /></span>
                    </ListItemIcon>
                    <ListItemText primary={"Hospital Surveillance"} primaryTypographyProps={{
                        style: { fontFamily: 'Rubik, sans-serif', fontWeight: 50, fontSize: '15px' }
                    }} />
                </ListItemButton>
                <ListItemButton
                    sx={{
                        '&.Mui-selected': {
                            backgroundColor: '#f3f4f7',
                            borderRadius: 4,
                            position: 'relative',
                            '&:hover': {
                                backgroundColor: '#f3f4f7',
                            },
                            '& .MuiListItemIcon-root': {
                                color: '#1677ff', // Replace 'blue' with your desired color
                                fontSize: '15px'
                            },
                            '& .MuiListItemText-primary': {
                                color: '#1677ff', // Replace 'blue' with your desired color
                                fontWeight: 1000,
                                fontSize: '15px',
                                fontFamily: 'Rubik, sans-serif'
                            },
                            '&:before': {
                                content: '""',
                                position: 'absolute',
                                width: '40px', // Adjust width as needed
                                height: '40px',
                                backgroundColor: '#212631', // Replace with your desired color
                                borderRadius: "50%",
                                top: '-40px',
                                right: 0,
                                boxShadow: '20px 20px 0 #f3f4f7',
                                zIndex: 1
                            },
                            '&:after': {
                                content: '""',
                                position: 'absolute',
                                width: '40px', // Adjust width as needed
                                height: '40px',
                                backgroundColor: '#212631', // Replace with your desired color
                                borderRadius: "50%",
                                bottom: '-40px',
                                right: 0,
                                boxShadow: '20px -20px 0 #f3f4f7',
                                zIndex: 1
                            }
                        },
                        pl: 4
                    }}

                    selected={selectedIndex == 3}
                    onClick={(event) => handleListItemClick(event, 3, "/ssfSurveillance")}
                >

                    <ListItemIcon sx={{ minWidth: '40px', fontSize: '15px', color: 'white' }}>
                        <span><FontAwesomeIcon icon={faBowlFood} /></span>
                    </ListItemIcon>
                    <ListItemText primary={<>
                        State Specific<br />Surveillance
                    </>} primaryTypographyProps={{
                        style: { fontFamily: 'Rubik, sans-serif', fontWeight: 50, fontSize: '15px' }
                    }} />
                </ListItemButton>
                <ListItemButton
                    sx={{
                        '&.Mui-selected': {
                            backgroundColor: '#f3f4f7',
                            borderRadius: 4,
                            position: 'relative',
                            '&:hover': {
                                backgroundColor: '#f3f4f7',
                            },
                            '& .MuiListItemIcon-root': {
                                color: '#1677ff', // Replace 'blue' with your desired color
                                fontSize: '15px'
                            },
                            '& .MuiListItemText-primary': {
                                color: '#1677ff', // Replace 'blue' with your desired color
                                fontWeight: 1000,
                                fontSize: '15px',
                                fontFamily: 'Rubik, sans-serif'
                            },
                            '&:before': {
                                content: '""',
                                position: 'absolute',
                                width: '40px', // Adjust width as needed
                                height: '40px',
                                backgroundColor: '#212631', // Replace with your desired color
                                borderRadius: "50%",
                                top: '-40px',
                                right: 0,
                                boxShadow: '20px 20px 0 #f3f4f7',
                                zIndex: 1
                            },
                            '&:after': {
                                content: '""',
                                position: 'absolute',
                                width: '40px', // Adjust width as needed
                                height: '40px',
                                backgroundColor: '#212631', // Replace with your desired color
                                borderRadius: "50%",
                                bottom: '-40px',
                                right: 0,
                                boxShadow: '20px -20px 0 #f3f4f7',
                                zIndex: 1
                            }
                        },
                        pl: 4
                    }}

                    selected={selectedIndex == 4}
                    onClick={(event) => handleListItemClick(event, 4, "/animalSurveillance")}
                >

                    <ListItemIcon sx={{ minWidth: '40px', fontSize: '15px', color: 'white' }}>
                        <span><FontAwesomeIcon icon={faPaw} /></span>
                    </ListItemIcon>
                    <ListItemText primary={"Animal Surveillance"} primaryTypographyProps={{
                        style: { fontFamily: 'Rubik, sans-serif', fontWeight: 50, fontSize: '15px' }
                    }} />
                </ListItemButton>


                {/* ******************************************Antibiogram details list****************************************** */}


                <Typography sx={{ marginLeft: 1, fontFamily: 'Rubik, sans-serif', fontWeight: 400, color: 'white', pl: 2, mt: 3, mb: "12px" }} variant="subtitle2" gutterBottom>Antibiogram Details</Typography>

                <ListItemButton
                    sx={{
                        '&.Mui-selected': {
                            backgroundColor: '#f3f4f7',
                            borderRadius: 4,
                            position: 'relative',
                            '&:hover': {
                                backgroundColor: '#f3f4f7',
                            },
                            '& .MuiListItemIcon-root': {
                                color: '#1677ff', // Replace 'blue' with your desired color
                                fontSize: '15px'
                            },
                            '& .MuiListItemText-primary': {
                                color: '#1677ff', // Replace 'blue' with your desired color
                                fontWeight: 1000,
                                fontSize: '15px',
                                fontFamily: 'Rubik, sans-serif'
                            },
                            '&:before': {
                                content: '""',
                                position: 'absolute',
                                width: '40px', // Adjust width as needed
                                height: '40px',
                                backgroundColor: '#212631', // Replace with your desired color
                                borderRadius: "50%",
                                top: '-40px',
                                right: 0,
                                boxShadow: '20px 20px 0 #f3f4f7',
                                zIndex: 1
                            },
                            '&:after': {
                                content: '""',
                                position: 'absolute',
                                width: '40px', // Adjust width as needed
                                height: '40px',
                                backgroundColor: '#212631', // Replace with your desired color
                                borderRadius: "50%",
                                bottom: '-40px',
                                right: 0,
                                boxShadow: '20px -20px 0 #f3f4f7',
                                zIndex: 1
                            }
                        },
                        pl: 4
                    }}

                    selected={selectedIndex == 5}
                    onClick={(event) => handleListItemClick(event, 5, "/amrMarketSurveillance")}
                >

                    <ListItemIcon sx={{ minWidth: '40px', fontSize: '15px', color: 'white' }}>
                        <span><i className='bx bxs-store-alt' style={{ fontSize: 20 }} ></i></span>
                    </ListItemIcon>
                    <ListItemText primary={"Market Surveillance"} primaryTypographyProps={{
                        style: { fontFamily: 'Rubik, sans-serif', fontWeight: 50, fontSize: '15px' }
                    }} />
                </ListItemButton>
                <ListItemButton
                    sx={{
                        '&.Mui-selected': {
                            backgroundColor: '#f3f4f7',
                            borderRadius: 4,
                            position: 'relative',
                            '&:hover': {
                                backgroundColor: '#f3f4f7',
                            },
                            '& .MuiListItemIcon-root': {
                                color: '#1677ff', // Replace 'blue' with your desired color
                                fontSize: '15px'
                            },
                            '& .MuiListItemText-primary': {
                                color: '#1677ff', // Replace 'blue' with your desired color
                                fontWeight: 1000,
                                fontSize: '15px',
                                fontFamily: 'Rubik, sans-serif'
                            },
                            '&:before': {
                                content: '""',
                                position: 'absolute',
                                width: '40px', // Adjust width as needed
                                height: '40px',
                                backgroundColor: '#212631', // Replace with your desired color
                                borderRadius: "50%",
                                top: '-40px',
                                right: 0,
                                boxShadow: '20px 20px 0 #f3f4f7',
                                zIndex: 1
                            },
                            '&:after': {
                                content: '""',
                                position: 'absolute',
                                width: '40px', // Adjust width as needed
                                height: '40px',
                                backgroundColor: '#212631', // Replace with your desired color
                                borderRadius: "50%",
                                bottom: '-40px',
                                right: 0,
                                boxShadow: '20px -20px 0 #f3f4f7',
                                zIndex: 1
                            }
                        },
                        pl: 4
                    }}

                    selected={selectedIndex == 6}
                    onClick={(event) => handleListItemClick(event, 6, "/amrHospitalSurveillance")}
                >

                    <ListItemIcon sx={{ minWidth: '40px', fontSize: '15px', color: 'white' }}>
                        <span><FontAwesomeIcon icon={faHospitalAlt} /></span>
                    </ListItemIcon>
                    <ListItemText primary={"Hospital Surveillance"} primaryTypographyProps={{
                        style: { fontFamily: 'Rubik, sans-serif', fontWeight: 50, fontSize: '15px' }
                    }} />
                </ListItemButton>
                <ListItemButton
                    sx={{
                        '&.Mui-selected': {
                            backgroundColor: '#f3f4f7',
                            borderRadius: 4,
                            position: 'relative',
                            '&:hover': {
                                backgroundColor: '#f3f4f7',
                            },
                            '& .MuiListItemIcon-root': {
                                color: '#1677ff', // Replace 'blue' with your desired color
                                fontSize: '15px'
                            },
                            '& .MuiListItemText-primary': {
                                color: '#1677ff', // Replace 'blue' with your desired color
                                fontWeight: 1000,
                                fontSize: '15px',
                                fontFamily: 'Rubik, sans-serif'
                            },
                            '&:before': {
                                content: '""',
                                position: 'absolute',
                                width: '40px', // Adjust width as needed
                                height: '40px',
                                backgroundColor: '#212631', // Replace with your desired color
                                borderRadius: "50%",
                                top: '-40px',
                                right: 0,
                                boxShadow: '20px 20px 0 #f3f4f7',
                                zIndex: 1
                            },
                            '&:after': {
                                content: '""',
                                position: 'absolute',
                                width: '40px', // Adjust width as needed
                                height: '40px',
                                backgroundColor: '#212631', // Replace with your desired color
                                borderRadius: "50%",
                                bottom: '-40px',
                                right: 0,
                                boxShadow: '20px -20px 0 #f3f4f7',
                                zIndex: 1
                            }
                        },
                        pl: 4
                    }}

                    selected={selectedIndex == 7}
                    onClick={(event) => handleListItemClick(event, 7, "/amrssfSurveillance")}
                >

                    <ListItemIcon sx={{ minWidth: '40px', fontSize: '15px', color: 'white' }}>
                        <span><FontAwesomeIcon icon={faBowlFood} /></span>
                    </ListItemIcon>
                    <ListItemText primary={<>
                        State Specific<br />Surveillance
                    </>} primaryTypographyProps={{
                        style: { fontFamily: 'Rubik, sans-serif', fontWeight: 50, fontSize: '15px' }
                    }} />
                </ListItemButton>
                <ListItemButton
                    sx={{
                        '&.Mui-selected': {
                            backgroundColor: '#f3f4f7',
                            borderRadius: 4,
                            position: 'relative',
                            '&:hover': {
                                backgroundColor: '#f3f4f7',
                            },
                            '& .MuiListItemIcon-root': {
                                color: '#1677ff', // Replace 'blue' with your desired color
                                fontSize: '15px'
                            },
                            '& .MuiListItemText-primary': {
                                color: '#1677ff', // Replace 'blue' with your desired color
                                fontWeight: 1000,
                                fontSize: '15px',
                                fontFamily: 'Rubik, sans-serif'
                            },
                            '&:before': {
                                content: '""',
                                position: 'absolute',
                                width: '40px', // Adjust width as needed
                                height: '40px',
                                backgroundColor: '#212631', // Replace with your desired color
                                borderRadius: "50%",
                                top: '-40px',
                                right: 0,
                                boxShadow: '20px 20px 0 #f3f4f7',
                                zIndex: 1
                            },
                            '&:after': {
                                content: '""',
                                position: 'absolute',
                                width: '40px', // Adjust width as needed
                                height: '40px',
                                backgroundColor: '#212631', // Replace with your desired color
                                borderRadius: "50%",
                                bottom: '-40px',
                                right: 0,
                                boxShadow: '20px -20px 0 #f3f4f7',
                                zIndex: 1
                            }
                        },
                        pl: 4
                    }}

                    selected={selectedIndex == 8}
                    onClick={(event) => handleListItemClick(event, 8, "/amrAnimalSurveillance")}
                >

                    <ListItemIcon sx={{ minWidth: '40px', fontSize: '15px', color: 'white' }}>
                        <span><FontAwesomeIcon icon={faPaw} /></span>
                    </ListItemIcon>
                    <ListItemText primary={"Animal Surveillance"} primaryTypographyProps={{
                        style: { fontFamily: 'Rubik, sans-serif', fontWeight: 50, fontSize: '15px' }
                    }} />
                </ListItemButton>
            </List>

        </div>
    );

    // Remove this const when copying and pasting into your project.
    const container = drawprops !== undefined ? () => drawprops().document.body : undefined;

    return (
        <Box sx={{ display: 'flex' }}>
            <CssBaseline />
            <AppBar
                position="fixed"
                elevation={0}
                sx={{
                    width: { sm: `calc(100% - ${drawerWidth}px)` },
                    ml: { sm: `${drawerWidth}px` },
                    backgroundColor: '#212631',
                    borderBottom: '0px solid rgb(255, 255, 255)',
                    '&:before': {
                        content: '""',
                        position: 'absolute',
                        width: '40px', // Adjust width as needed
                        height: '40px',
                        backgroundColor: '#f3f4f7', // Replace with your desired color
                        bottom: "-40px",
                        left: 0,
                        borderRadius: "50%",
                        boxShadow: '-20px -20px 0 #212631',
                        zindex: -1
                    }
                }}
            >
                <Toolbar sx={{
                    borderBottom: '0px solid rgb(255, 255, 255)'
                }}>
                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        edge="start"
                        onClick={handleDrawerToggle}
                        sx={{ mr: 2, display: { sm: 'none' }, color: 'black' }}
                    >
                        <MenuIcon />
                    </IconButton>
                    <Typography variant="h5" noWrap component="div" color='white' sx={{ fontFamily: 'Rubik', fontWeight: 300 }} >
                        ICMR FOODNET DASHBOARD
                    </Typography>
                </Toolbar>
            </AppBar>
            <Box
                component="nav"
                sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
                aria-label="mailbox folders"
            >
                {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
                <Drawer
                    PaperProps={{
                        sx: {
                            backgroundColor: "#ffffff",
                            color: "white",
                            borderRight: '0px solid',
                            overflow: 'hidden'
                        }
                    }}

                    container={container}
                    variant="temporary"
                    open={mobileOpen}
                    onClose={handleDrawerToggle}
                    ModalProps={{
                        keepMounted: true, // Better open performance on mobile.
                    }}
                    sx={{
                        display: { xs: 'block', sm: 'none' },
                        '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth, borderColor: '#f0f0f0' },

                    }}
                >
                    <Paper sx={{
                        height: '100%',
                        backgroundColor: '#212631', color: 'white',
                        boxShadow: "0px 0px 0px 0px rgba(0, 0, 0, 0)",
                        display: 'flex', flexDirection: 'column', justifyContent: 'space-between',
                        marginBottom: 2
                    }}>
                        <div>
                            <div style={{
                                display: 'grid', alignItems: 'center',
                                justifyContent: 'center', backgroundColor: 'white',
                                borderRadius: '5px', padding: '10px', marginTop: '15px', marginLeft: '10px', marginRight: '10px'
                            }}>
                                <img src={foodnetlogo} width={'120px'} height={'70px'}></img>
                            </div>
                        </div>

                        <div
                            style={{
                                flexGrow: 1, // Ensures this section takes up remaining space
                                overflowY: 'scroll', // Enables scrolling
                                marginTop: '10px',
                                scrollbarWidth: 'none', // For Firefox
                                msOverflowStyle: 'none', // For Internet Explorer and Edge
                                '&::WebkitScrollbar': {
                                    display: 'none', // For Chrome, Safari, and Edge
                                },
                            }}
                            sx={{
                                '&::WebkitScrollbar': {
                                    display: 'none', // For Chrome, Safari, and Edge
                                },
                            }}
                        >
                            {drawer}
                        </div>

                        <div style={{
                            display: 'flex', alignItems: 'center',
                            justifyContent: 'center', backgroundColor: '#212631',
                            borderRadius: '5px', marginTop: '10px', flexDirection: 'column'
                        }}>
                            <div>
                                <img src={cdac} width={'60px'} height={'60px'}></img>
                            </div>
                            <h6 style={{ color: 'white', fontSize: 14, textAlign: 'center', fontWeight: 'bold', marginTop: '3px' }}>Designed and Developed by <br></br> C-DAC, Kolkata</h6>
                        </div>
                    </Paper>
                </Drawer>


                <Drawer
                    PaperProps={{
                        sx: {
                            backgroundColor: "#212631",
                            color: "white",
                            alignItems: 'center',
                            justifyContent: 'center',
                            borderRight: '0px solid',
                            overflow: 'hidden'
                        }
                    }}
                    variant="permanent"

                    sx={{
                        display: { xs: 'none', sm: 'block' },
                        '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth, borderColor: '#f0f0f0' },
                    }}
                    open
                >
                    <Paper sx={{
                        height: '100%',
                        width: '100%',
                        backgroundColor: '#212631', color: 'white',
                        boxShadow: "0px 0px 0px 0px rgba(0, 0, 0, 0)",
                        display: 'flex', flexDirection: 'column', justifyContent: 'space-between',
                        marginBottom: 2
                    }}>
                        <div>
                            <div style={{
                                display: 'grid', alignItems: 'center',
                                justifyContent: 'center', backgroundColor: 'white',
                                borderRadius: '10px', padding: '5px', marginTop: '15px', marginLeft: '20px', marginRight: '20px'
                            }}>
                                <img src={foodnetlogo} width={'120px'} height={'70px'}></img>
                            </div>
                        </div>

                        <div
                            style={{
                                flexGrow: 1, // Ensures this section takes up remaining space
                                overflowY: 'scroll', // Enables scrolling
                                marginTop: '10px',
                                scrollbarWidth: 'none', // For Firefox
                                msOverflowStyle: 'none', // For Internet Explorer and Edge
                                '&::WebkitScrollbar': {
                                    display: 'none', // For Chrome, Safari, and Edge
                                },
                            }}
                            sx={{
                                '&::WebkitScrollbar': {
                                    display: 'none', // For Chrome, Safari, and Edge
                                },
                            }}
                        >
                            {drawer}
                        </div>


                        <div style={{
                            display: 'flex', alignItems: 'center',
                            justifyContent: 'center', backgroundColor: '#212631',
                            borderRadius: '5px', marginTop: '10px', flexDirection: 'column'
                        }}>
                            <div>
                                <img src={cdac} width={'60px'} height={'60px'}></img>
                            </div>
                            <h6 style={{ color: 'white', fontSize: 14, textAlign: 'center', fontWeight: 'bold', marginTop: '3px' }}>Designed and Developed by <br></br> C-DAC, Kolkata</h6>
                        </div>
                    </Paper>

                </Drawer>
            </Box>
        </Box>
    );
}

ResponsiveDrawer.propTypes = {
    /**
     * Injected by the documentation to work in an iframe.
     * Remove this when copying and pasting into your project.
     */
    drawprops: PropTypes.func,
};

export default ResponsiveDrawer;